module.exports = require("react-bootstrap/Tabs");